module.exports = __webpack_public_path__ + "static/media/lt_mob_s.eff2abfe.png";